import * as React from 'react';
import { connect } from 'react-redux';
import { map } from 'lodash';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { filterByStatusAction, filterByUrlAction, PlacementData, togglePlacementStatus } from './PlacementOperation';
import PlacementsTable from './PlacementsTable';

export interface PlacementsListProps {
  placements: { all: Array<PlacementData> };
  charities: { all: Array<any> };
  toggleAction: (uid: string, placement: PlacementData) => void;
  filterByStatus: (status: boolean) => void;
  filterByUrl: (query: string) => void;
  statusFilter: boolean;
  urlFilter: string;
}

const styles = {
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '60px 0'
  }
}
class PlacementsListComponent extends React.Component<PlacementsListProps> {
  render() {
    const { charities, classes } = this.props;
    const results = this.filterAllResults();
    return (
      <div>
        <div className={classes.flex}>
          <Typography variant="display1">Widget Placements</Typography>
          <div className=" filters-container">
            <div className="buttons is-right is-half">
              <label className="checkbox">
                <input type="checkbox" onChange={this.toggleFilterActive}/> Filter active &nbsp;
              </label>

              <div className="control filter-input">
                <input
                  onChange={this.filterDomain}
                  className="input"
                  type="text"
                  placeholder="Filter by url"
                />
              </div>
            </div>
          </div>
        </div>
        <Paper style={{padding: 20}}>
          <PlacementsTable 
            placements={results}
            toggleStatus={this.toggleStatus}
            charities={charities.all}
          />
        </Paper>
      </div>
    );
  }

  filterAllResults = () => {
    const { statusFilter, urlFilter, placements } = this.props;
    let results: any = { ...placements };
    if (statusFilter) {
      const statusFilteredRes = {};
      map(results, (el: PlacementData, key) => {
        if (el.active === true) {
          statusFilteredRes[ key ] = el;
        }
      });
      results = { ...statusFilteredRes };
    }

    if (urlFilter.trim().length) {
      const urlFilteredRes = {};
      map(results, (el: PlacementData, key) => {
        if (el.url.includes(urlFilter)) {
          urlFilteredRes[key] = el;
        }
      });
      results = { ...urlFilteredRes };
    }

    return results;
  }

  toggleStatus = (uid: string, status: boolean) => {
    const { placements, toggleAction } = this.props;
    const placement = placements[ uid ];
    const newPlacement = {
      ...placement,
      active: !status
    };
    return toggleAction(uid, newPlacement);
  }

  toggleFilterActive = (ev) => {
    this.props.filterByStatus(ev.target.checked);
  }

  filterDomain = (ev) => {
    this.props.filterByUrl(ev.target.value);
  }
}

function mapStateToProps({ placements, charities }: any) {
  return {
    placements: placements.all,
    statusFilter: placements.statusFilter,
    urlFilter: placements.urlFilter,
    charities
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    toggleAction: (uid: string, placement: PlacementData) => dispatch(togglePlacementStatus(uid, placement)),
    filterByStatus: (status: boolean) => dispatch(filterByStatusAction(status)),
    filterByUrl: (query: string) => dispatch(filterByUrlAction(query))
  };
}

const PlacementsList = connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PlacementsListComponent));

export { PlacementsList };
